import React from 'react';
import { Grid, Paper, Card, CardContent, Tooltip } from '@material-ui/core';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';

export const StatCard = function(props) {
  const { title, text, subText, cardIndex, arrow, cardFooter, xs, sm, linkTo, padding } = props;
  const cardColor = 'c' + String((cardIndex % 4) + 1)

  const cardContentStyles = css(Styles.cardcontent, padding === 'small' ? Styles.lesshpadding : '')
  const card =
    <Card className={props.handleCardClick ? css([Styles.card, props.cardStyle, Styles.clickableCard, Styles[cardColor]]) : css([Styles.card, props.cardStyle, Styles[cardColor]])} elevation={0} onClick={props.handleCardClick ? ()=>props.handleCardClick(props.cardId || '') : null}>
      <CardContent className={cardContentStyles}>
        <div className={css(Styles.text)}>{text}</div>
        <div className={css(Styles.subText)}>&nbsp;&nbsp;{subText}</div>
        {props.handleCardClick &&
          <Tooltip title={subText} classes={{ popper: css(Styles.tooltip) }} className={css(Styles.touchIconTooltip)}>
            <i className='material-icons-outlined'>filter_alt</i>
          </Tooltip>
        }
      </CardContent>
    </Card>

  return (
    <Grid item xs={xs || 6} sm={sm || 3} className={css([Styles.container, props.containerStyle])}>
      {title && <div className={css(Styles.paperTitle)} elevation={0}>
        {title}
      </div>}

      {linkTo && (
        <Link className={css(Styles.statLink)} to={linkTo}>
          {card}
        </Link>
      )}

      {!linkTo && (
        card
      )}

      {cardFooter && (
        <div className={css(Styles.paperFooter)} elevation={0}>
          {arrow === 'down' && (
            <i class={'material-icons-outlined ' + css(Styles.arrow, Styles.arrowDown)}>keyboard_arrow_down</i>
          )}
          {arrow === 'up' && <i class={'material-icons-outlined ' + css(Styles.arrow, Styles.arrowUp)}>keyboard_arrow_up</i>}
          {cardFooter}
        </div>
      )}
    </Grid>
  );
};

const Styles = StyleSheet.create({
  container: {
    color: '#474747',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media (max-width: 767px)': {
      alignItems: 'center',
    },
  },
  paperFooter: {
    margin: '10px',
    display: 'flex',
    verticalAlign: 'top'
  },
  paperTitle: {
    marginTop: '10px',
    fontWeight: 'bold'
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 10,
    height: '100%',
    '@media (max-width: 1024px)': {
      width: '99%'
    },
    '@media (max-width: 767px)': {
      width: '98%'
    },
  },
  clickableCard: {
    position: 'relative',
    cursor: 'pointer'
  },
  cardcontent: {
    padding: '32px 24px',
    width: '100%',
  },
  lesshpadding: {
    padding: '12px 24px',
    '@media (max-width: 767px)': {
      padding: '12px 2px',
    },
  },
  text: {
    color: 'black',
    display: 'block',
    fontSize: 36,
    // lineHeight: '48px',
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'center',
    '@media (max-width: 767px)': {
      fontSize: 24,
    },
  },
  subText: {
    color: 'black',
    display: 'block',
    fontSize: 12,
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'center',
    '@media (max-width: 767px)': {
      fontSize: 10,
    },
  },
  arrowUp: {
    color: 'green'
  },
  arrowDown: {
    color: 'red'
  },
  c1: {
    background: '#FFD7BB'
  },
  c2: {
    background: '#FFE1EE'
  },
  c3: {
    background: '#A9E3FF'
  },
  c4: {
    background: '#3BDE86'
  },
  statLink: {
    textDecoration: 'none'
  },
  tooltip: {
    zIndex: 9999999999,
    maxWidth: 250
  },
  touchIconTooltip: {
    position: 'absolute',
    top: '25%',
    right: 5,
    transform: 'translateY(-50%)',
    fontSize: 26,
    color: '#0000008A',
    cursor: 'pointer',
    '@media (max-width: 767px)': {
      fontSize: 20,
    },
  }
});
